"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/web.dom-collections.for-each.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _etude = require("etude");

var _react = _interopRequireWildcard(require("react"));

var _EtudeUtils = require("./EtudeUtils");

require("./Piano.css");

var _PianoKey = _interopRequireDefault(require("./PianoKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Letter = _etude.theory.Letter,
    Pitch = _etude.theory.Pitch,
    Policy = _etude.theory.Policy,
    Scale = _etude.theory.Scale;
var WHITE_KEY_WIDTH = 30; // for memo to recognize equality when a default no-op prop is needed

var NO_OP_KEY_ACTION = function NO_OP_KEY_ACTION() {};

function Piano(_ref) {
  var start = _ref.start,
      end = _ref.end,
      _ref$accidentalPolicy = _ref.accidentalPolicy,
      accidentalPolicy = _ref$accidentalPolicy === void 0 ? Policy.DEFAULT_PRIORITY : _ref$accidentalPolicy,
      _ref$onKeyPress = _ref.onKeyPress,
      onKeyPress = _ref$onKeyPress === void 0 ? NO_OP_KEY_ACTION : _ref$onKeyPress,
      _ref$onKeyRelease = _ref.onKeyRelease,
      onKeyRelease = _ref$onKeyRelease === void 0 ? NO_OP_KEY_ACTION : _ref$onKeyRelease,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === void 0 ? [] : _ref$highlight,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel;

  function getPitches(start, end, accidentalPolicy) {
    var startPitch = Pitch.fromString(start).orElseThrow(function () {
      return new Error("Invalid start pitch.");
    });
    var endPitch = Pitch.fromString(end).orElseThrow(function () {
      return new Error("Invalid end pitch.");
    });

    if ((0, _EtudeUtils.isBlackKey)(startPitch) || (0, _EtudeUtils.isBlackKey)(endPitch)) {
      throw new Error("Start and end of piano should be a white key.");
    } // + 1 to include end pitch


    var numberOfPitches = endPitch.getProgramNumber() - startPitch.getProgramNumber() + 1;

    if (numberOfPitches <= 0) {
      throw new Error("End pitch should be the same as or after the start pitch.");
    }

    var whitePitches = [];
    var blackPitches = [];
    var scale = new Scale(startPitch, Scale.Quality.CHROMATIC);
    scale.stream(accidentalPolicy).limit(numberOfPitches).forEach(function (p) {
      if ((0, _EtudeUtils.isBlackKey)(p)) {
        blackPitches.push(p);
      } else {
        whitePitches.push(p); // add invisible black key for gap

        var normalizedPitch = Pitch.fromProgramNumber(p.getProgramNumber()).get();

        if (normalizedPitch.getKey().getLetter() === Letter.E || normalizedPitch.getKey().getLetter() === Letter.B) {
          blackPitches.push(null);
        }
      }
    });
    return {
      whitePitches: whitePitches,
      blackPitches: blackPitches
    };
  }

  function getHighlightPitches(highlight) {
    if (highlight == null) {
      return [];
    }

    return highlight.length > 0 && typeof highlight[0] === "string" ? highlight.map(function (s) {
      return Pitch.fromString(s).orElseThrow(function () {
        return new Error("Invalid highlight pitch.");
      });
    }) : highlight;
  }

  var _useMemo = (0, _react.useMemo)(function () {
    return getPitches(start, end, accidentalPolicy);
  }, [start, end, accidentalPolicy]),
      whitePitches = _useMemo.whitePitches,
      blackPitches = _useMemo.blackPitches;

  var highlightPitches = (0, _react.useMemo)(function () {
    return getHighlightPitches(highlight);
  }, [highlight]);
  var width = "".concat(whitePitches.length * WHITE_KEY_WIDTH, "px");

  function renderPianoKey(pitch, i) {
    var highlightPitch = pitch == null ? null : highlightPitches.find(function (h) {
      return Pitch.isEnharmonic(h, pitch);
    });
    var isHighlight = pitch != null && highlightPitch != null;
    return (
      /*#__PURE__*/
      // key prop is required for loops; key prop is NOT music key
      _react["default"].createElement(_PianoKey["default"], {
        key: i,
        pitch: isHighlight ? highlightPitch : pitch,
        isHighlight: isHighlight,
        onKeyPress: onKeyPress,
        onKeyRelease: onKeyRelease,
        showLabel: showLabel
      })
    );
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "piano",
    style: {
      width: width
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "keys white-keys"
  }, whitePitches.map(renderPianoKey)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "keys black-keys"
  }, blackPitches.map(renderPianoKey)));
}

var _default = Piano;
exports["default"] = _default;